module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "frn"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("CAST OF CHARACTERS")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Roderick Alleyn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Chief Detective-Inspector, CID, New Scotland Yard")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Agatha Troy")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("His Wife")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Miss Truebody")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Their fellow-passenger")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Dr Claudel")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("A French physician")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Raoul Milano")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Of Roqueville, Owner-driver")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Dr Ali Baradi")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("A surgeon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Mahomet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("His servant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Mr Oberon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Of the Château de la Chèvre d’Argent")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "space",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Ginny Taylor"), _c('br'), _vm._v("\n      Robin Herrington"), _c('br'), _vm._v("\n      Carbury Glande"), _c('br'), _vm._v("\n      Annabella Wells")])]), _vm._v(" "), _c('td', {
    staticClass: "space",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("His guests")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "space",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Teresa")])]), _vm._v(" "), _c('td', {
    staticClass: "space",
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("The fiancée of Raoul")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("M. Dupont")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Of the Sûreté. Acting Commissaire at the Préfecture, Roqueville")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("M. Callard")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Managing Director of the Compagnie Chimique des Alpes Maritimes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("M. & Madame Milano")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("The parents of Raoul")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("Marie")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("A maker of figurines")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("M. Malaquin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("Proprietor of the Hôtel Royal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle5"
  }, [_vm._v("P. E. Garbel")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "textStyle8"
  }, [_vm._v("A chemist")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790f1464","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FrontOther01.vue
// module id = 66
// module chunks = 0